import styled from 'styled-components'

export const Separator = styled.div`
  display: block;
  width: 1px;
  height: 80%;
  background: ${p => p.theme.colors.$whiteSmoke};
`
Separator.displayName = 'Separator'
